import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false, // 是否展示loading动画
    orderBy: 'sale', // 根据什么字段排序
    goodsInfo: { // 商品详情
      goodsImg: [],
      title: '',
      tags: [],
      discount: [],
      promotion: [],
      remarksNum: 0,
      setMeal: [],
      hot: [],
      goodsDetail: [],
      param: [],
      remarks: []
    },
    userInfo: { // 用户信息
      username: ''
    },
    signUpStep: 0, // 登陆步骤

    seckills: { // 秒杀
      deadline: {
        hours: 0,
        minute: 0,
        seconds: 0
      },
      goodsList: []
    },
    computer: {}, // 电脑专栏
    eat: {}, // 爱吃专栏
    asItems: [], // 广告
    goodsList: [], // 商品列表
    shoppingCart: [], // 购物车
    totalPrice:0,//购物车已知总金额
    newShoppingCart: [], // 刚加入的购物车，作为展示
    recommend: [], // 推荐购买
    showLogin:false,//是否显示登录弹窗
    showLoading:false,//是否显示加载中
    orderComList:[],//订单商品列表
    showNews:true,
    showNewsAlert:true,

    //===============================
    topCategories: [], //一级产品大类
    //token
    token: null,
    allMainCategories: [], //123级产品大类

    marketing: { // 营销
      carouselItems: [], // 轮播图
      brandItems: [], //轮播图下方的4个品牌
      userAd: {},   //首页用户下方的广告图
    },

    //产品列表页，筛选条件是否展开
    showFilterMore: true,

    productList:[], //智能报价列表

    isErp:false,
    showPack:false,
    category:{},
    titlePhone:"",
    HomeBanner:[],
    username:""

  },
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js